import { Button } from '@backstage/ui';
import { RiCloseLine } from '@remixicon/react';

import styles from './ClearItemsButton.module.css';

export interface ClearItemsButtonProps {
  /** Number of selected items, shown in the pill. */
  activeItems: string;
  onClear: () => void;
  /**
   * Accessible name.
   * @defaultValue `Clear ${activeItems} selected`
   */
  'aria-label'?: string;
  className?: string;
  iconClassName?: string;
}

/**
 * Pill with the number of selected items and a cross that clears them, on
 * the Backstage UI `Button`.
 *
 * @example
 * <ClearItemsButton activeItems={`${selected.length}`} onClear={reset} />
 */
export const ClearItemsButton = ({
  activeItems,
  onClear,
  'aria-label': ariaLabel,
  className,
  iconClassName,
}: ClearItemsButtonProps) => (
  <Button
    variant="primary"
    size="small"
    aria-label={ariaLabel ?? `Clear ${activeItems} selected`}
    className={[styles.button, className].filter(Boolean).join(' ')}
    iconEnd={
      <RiCloseLine
        aria-hidden
        data-testid="ClearIcon"
        className={[styles.icon, iconClassName].filter(Boolean).join(' ')}
      />
    }
    data-testid="clear-button"
    onPress={onClear}
  >
    <span data-testid="clear-button-items">{activeItems}</span>
  </Button>
);
